<template>
  <div>
    <b-row>
      <b-col cols="12" md="4">
        <b-form-group label="Data *" label-for="tf-data">
          <b-form-input
            id="tf-data"
            v-model="form.data"
            type="date"
            required
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4">
        <b-form-group label="Conta Origem *" label-for="tf-origem">
          <b-form-select
            id="tf-origem"
            v-model="form.contaOrigem"
            :options="comboContas"
            value-field="id"
            text-field="descricao"
          >
            <template #first>
              <b-form-select-option :value="null">Selecione...</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4">
        <b-form-group label="Conta Destino *" label-for="tf-destino">
          <b-form-select
            id="tf-destino"
            v-model="form.contaDestino"
            :options="contasDestinoFiltradas"
            value-field="id"
            text-field="descricao"
          >
            <template #first>
              <b-form-select-option :value="null">Selecione...</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" md="4">
        <b-form-group label="Valor *" label-for="tf-valor">
          <b-input-group prepend="R$">
            <b-form-input
              id="tf-valor"
              v-model="form.valor"
              type="number"
              step="0.01"
              min="0.01"
            />
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="8">
        <b-form-group label="Observação" label-for="tf-obs">
          <b-form-input
            id="tf-obs"
            v-model="form.obs"
            type="text"
            placeholder="Observação da transferência (opcional)"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <div class="d-flex justify-content-end gap-1 mt-1">
      <b-button variant="outline-secondary" @click="$emit('cancelar')">
        Cancelar
      </b-button>
      <b-button variant="primary" :disabled="!isFormValido" @click="salvar">
        <feather-icon :icon="modoEdicao ? 'SaveIcon' : 'CheckIcon'" size="14" class="mr-50" />
        {{ modoEdicao ? 'Salvar Alterações' : 'Salvar Transferência' }}
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormSelect,
  BFormSelectOption, BButton, BInputGroup
} from 'bootstrap-vue'

export default {
  name: 'FormTransferenciaConta',
  components: {
    BRow, BCol, BFormGroup, BFormInput, BFormSelect,
    BFormSelectOption, BButton, BInputGroup
  },
  props: {
    comboContas: {
      type: Array,
      default: () => []
    },
    /** Quando fornecido, o formulário opera em modo de edição */
    objectEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        id: null,
        contaOrigem: null,
        contaDestino: null,
        data: new Date().toISOString().split('T')[0],
        valor: null,
        obs: ''
      }
    }
  },
  computed: {
    modoEdicao() {
      return !!this.objectEdit && !!this.objectEdit.id
    },
    contasDestinoFiltradas() {
      return this.comboContas.filter(c => c.id !== this.form.contaOrigem)
    },
    isFormValido() {
      return this.form.contaOrigem &&
        this.form.contaDestino &&
        this.form.contaOrigem !== this.form.contaDestino &&
        this.form.data &&
        this.form.valor &&
        parseFloat(this.form.valor) > 0
    }
  },
  watch: {
    /** Reage sempre que o pai muda o objectEdit (troca de registro ou reset) */
    objectEdit: {
      immediate: true,
      handler(val) {
        if (val && val.id) {
          this.form = {
            id: val.id,
            contaOrigem: val.contaOrigem ? val.contaOrigem.id : null,
            contaDestino: val.contaDestino ? val.contaDestino.id : null,
            data: val.data || new Date().toISOString().split('T')[0],
            valor: val.valor,
            obs: val.obs || ''
          }
        } else {
          this.form = {
            id: null,
            contaOrigem: null,
            contaDestino: null,
            data: new Date().toISOString().split('T')[0],
            valor: null,
            obs: ''
          }
        }
      }
    }
  },
  methods: {
    salvar() {
      if (!this.isFormValido) return
      const payload = {
        id: this.form.id,
        contaOrigem: { id: this.form.contaOrigem },
        contaDestino: { id: this.form.contaDestino },
        data: this.form.data,
        valor: parseFloat(this.form.valor),
        obs: this.form.obs || null
      }
      this.$emit('save', payload)
    }
  }
}
</script>
